module.exports = __webpack_public_path__ + "img/Bibliogra_fruit@2x-100.830e8708.jpg";